module.exports = __webpack_public_path__ + "static/media/ThumbnailStill05.f3ae0013.png";